import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export interface IGetReportingPeriodsByFrequencyParams {
  readonly pay_schedule: string;
  /** ISO YYYY-MM-DD; backend returns only period(s) containing this day. */
  readonly pay_date?: string;
}

export const getReportingPeriodsByFrequency = (axios: IAxiosInstance) => {
  return async (params: IGetReportingPeriodsByFrequencyParams) => {
    const { pay_schedule, pay_date } = params;
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetReportingPeriodsByFrequencyResponse"]
    >(`/api/getReportingPeriodsByFrequency`, {
      params: {
        pay_schedule,
        ...(pay_date !== undefined && pay_date.length > 0 ? { pay_date } : {}),
      },
    });
    const data = response.data;

    if (data.success) {
      return data;
    }

    throw new Error("Something went wrong");
  };
};
